<template>
    <div>
        <el-dialog :title="ImportConfig.errorTitle || '导入'" :visible.sync="orderImport" width="50%" class="carrierConfigUpload">
            <el-row :gutter="5">
                <el-col :span="12">
                    <el-upload
                        class="upload-demo"
                        ref="upload"
                        :on-error="handleError"
                        :before-upload="beforeUpload"
                        :action="ImportConfig.action"
                        :on-preview="handlePreview"
                        :on-remove="handleRemove"
                        :auto-upload="!ImportConfig.manualUpload"
                        :multiple="ImportConfig.multiple"
                        :show-file-list="ImportConfig.showFileList"
                        :accept="ImportConfig.accept"
                        :on-exceed="handleExceed"
                        :limit="1"
                        :data="ImportConfig.extraData"
                        :with-credentials="true"
                        :on-success="onSuccess"
                        :file-list="fileList"
                    >
                        <el-button size="small" type="primary">点击上传</el-button>
                        <span slot="tip" class="el-upload__tip">上传要求：{{ ImportConfig.fileType }}</span>
                    </el-upload>
                </el-col>
            </el-row>
            <div class="error_box" key="error" v-if="errorMsgText && failNum>0">
                <div
                    class="import-error-box"
                >
                    <div class="show-num-box">
                        <div class="success">成功数据：{{ successNum }}</div>
                        <div class="error">失败数据：{{ failNum }}</div>
                        <el-link type="primary" :href="errorUrl" :underline="false"
                        >{{ ImportConfig.errorDownloadContent || '导入失败下载' }}<i class="el-icon-download"></i>
                        </el-link>
                    </div>
                </div>
            </div>
            <template v-if="errorMsgList.length > 0">
                <ul class="error-text">
                    <li v-for="(msg, index) in errorMsgList" :key="index">{{ msg }}</li>
                </ul>
            </template>
            <div class="error-text" v-if="errorMsgText">
                {{ errorMsgText }}
            </div>
            <div class="success-text" v-if="successMsgText">{{ successMsgText }}</div>
            <el-collapse @change="handleChange">
                <el-collapse-item title="模板" name="1">
                    <div class="template_flex" v-for="(item, index) in ImportContent" :key="index">
                        <div class="template_left">
                            <img src="@/assets/template.png" />
                            <div class="template">
                                <div>{{ item.fileName }}</div>
                                <div>{{ item.fileSize }}</div>
                            </div>
                        </div>
                        <div class="template_float">
                            <i v-if="item.upLoadFlag" class="el-icon-upload2 modelBtn" @click="handleUpload(item)"></i>
                            <i class="el-icon-download modelBtn" @click="handleDownload(item)"></i>
                        </div>
                    </div>
                </el-collapse-item>
            </el-collapse>

            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveData">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data () {
        return {
            fileList: [],
            fileList2: [],
            errorMsgList: [],
            errorMsgText: '',
            successMsgList: [],
            successMsgText: '',
            orderImport: false,
            upLoadInfo: {}, // 上传信息
            uploadInput: {},
            flag: false, // 一个上不了页面的input标签
            successFlag: false,
            errorUrl: '',
            successNum: 0,
            failNum: 0,
            fileName: ''
        };
    },
    props: ['ImportConfig', 'ImportContent'],
    created () {
        // 创建导入功能使用的Input标签并添加监听
        this.createInput();
    },
    methods: {
        //  触发弹窗
        orderImportC () {
            this.errorMsgList = [];
            this.errorMsgText = '';
            this.successMsgText = '';
            this.fileList = [];
            this.fileList2 = [];
            this.orderImport = true;
        },
        // 创建导入功能使用的Input标签并添加监听
        createInput () {
            if (!this.flag) {
                return;
            }
            // 创建input标签并添加监听
            this.uploadInput = document.createElement('input');
            this.uploadInput.type = 'file';
        },
        // 上传模板
        handleUpload (item) {
            if (!this.flag) {
                return;
            }
            this.upLoadInfo = item.upLoadInfo;
            this.uploadInput.click();
        },
        beforeUpload (file) {
            this.errorMsgList = [];
            this.errorMsgText = '';
            this.successMsgText = '';
            const isText = file.type === 'application/vnd.ms-excel';
            const isTextComputer = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            if (!(isText || isTextComputer)) {
                this.$message.warning(this.ImportConfig.fileType);
                return (isText || isTextComputer);
            }
        },
        // 下载模板
        handleDownload (item) {
            if (!item.downLoadInfo.url) {
                this.$message.warning('获取模板下载地址失败，刷新页面重试');
                return;
            }
            window.location = item.downLoadInfo.url;
        },
        // 上传失败
        handleError () {
            this.$message.warning('上传失败');
        },
        onSuccess (res) {
            this.errorUrl = '';
            if (res && res.code === '0') {
                this.$message.success('导入成功');
                this.successMsgText = this.ImportConfig.fixSuccessfulMsg ? '导入成功' : (res.msg || res.data);
                this.errorMsgText = '';
                this.successFlag = true;
            } else if (res && res.code === '1') {
                // 兼容原来的url拼接情况
                if (res.msg.includes('url:')) {
                    const arr = this.extractBeforeAndAfter(res.msg);
                    this.errorUrl = arr[1];
                    this.errorMsgText = arr[0];
                }
                // 新的返回结构约定data，里面有导入总条数，失败/成功条数及失败后下载的url。如果返回{}就没有url
                if (res.data && res.data.url) {
                    this.failNum = res.data.failNum;
                    this.successNum = res.data.successNum;
                    this.errorUrl = res.data.url;
                    this.fileName = res.data.fileName;
                }
                this.errorMsgText = this.errorMsgText || res.msg;
            } else {
                try {
                    this.errorMsgList = JSON.parse(res.msg);
                } catch (error) {
                    this.errorMsgText = res.msg;
                }
            }
        },
        importFail (url) {
            if (!url) return;
            // 这是文件的下载URL
            const fileUrl = url;
            // 名字后端写死了前端改不了
            const fileName = this.fileName || '导入失败异常数据.xls';
            const link = document.createElement('a');
            link.href = fileUrl;
            link.download = fileName;
            link.click();
        },
        handleChange (val) {
            // 导入下拉
        },
        handleRemove (file, fileList) {
            // 行内删除
        },
        handlePreview (file) {
        },
        handleExceed (files, fileList) {
            this.$message.warning(`版本暂时不支持同时上传多个文件`);
        },
        extractBeforeAndAfter (str, marker = 'url:') {
            // 传入被处理的字符串，根据标识去头去尾，默认url:
            const regex = new RegExp(`(.*)(?:${marker})(.*)`);
            const match = str.match(regex);
            if (match !== null) {
                return [match[1], match[2]];
            } else {
                return ['', ''];
            }
        },
        saveData () {
            // 保存
            if (this.successFlag) {
                this.$emit('reflashList', true);
                this.successFlag = false;
            }
            this.orderImport = false;
        }
    }
};
</script>

<style lang="less">
.carrierConfigUpload {
    font-size: 18px;
    margin-top: 6vh;
    .upload-demo {
        margin-top: 20px;
    }
    .error-text {
        color: #fff;
        background: #f56c6c;
        line-height: 2;
        padding: 5px 15px;
        border-radius: 5px;
        margin-top: 10px;
    }
    .success-text {
        color: #fff;
        background: #63d287;
        line-height: 2;
        padding: 5px 15px;
        border-radius: 5px;
        margin-top: 10px;
    }
    .el-upload__tip {
        margin-left: 20px;
        color: #999999;
    }

    .el-upload-list {
        padding: 0 10px;
        max-height: 60px;
        overflow-y: auto;
        margin-top: 15px;
    }

    .el-collapse-item__header {
        font-size: 14px;
        background-color: #f2f2f2;
        padding-left: 10px;
        color: #a3a3a3;
        margin-top: 10px;
        height: 40px;
        line-height: 40px;

        .el-icon-document:before {
            content: '\E614';
        }
    }

    .el-collapse {
        border: none;
    }

    .el-collapse-item__content {
        padding-bottom: 10px;
        max-height: 140px;
        overflow-y: auto;
    }

    .el-dialog__body {
        padding: 10px 10px;
    }

    .template_flex {
        display: flex;
        position: relative;
        margin-top: 10px;
        padding: 10px;
        border-bottom: 1px solid #f2f2f2;
    }

    .template_left {
        display: flex;
    }

    .template_left img {
        width: 30px;
        height: 40px;
    }

    .template {
        margin-left: 15px;
        font-size: 12px;
    }

    .template_float {
        font-size: 14px;
        letter-spacing: 10px;
        color: #00bcbf;
        position: absolute;
        right: 15px;
        top: 50%;
        transform: translateY(-50%);

        .modelBtn {
            font-size: 18px;
            cursor: pointer;
        }
    }

    .el-collapse-item__wrap {
        border-bottom: none;
    }
    .error_box {
        border-radius: 5px;
        padding-top: 10px;
    }
}
.import-error-box {
    .show-num-box {
        padding: 10px;
        .error {
            height: 20px;
            line-height: 1;
            font-size: 14px;
            color: #f56c6c;
        }
        .success {
            height: 20px;
            line-height: 1;
            font-size: 14px;
            color: #c0c4cc;
        }
    }
}
</style>